// src/shared/components/LanguageSwitcher/LanguageSwitcher.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.scss';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button className={styles.languageSwitcher} onClick={toggleLanguage}>
      {i18n.language.toUpperCase() === 'FR' ? 'FR' : 'EN'}
    </button>
  );
};

export default LanguageSwitcher;